<template>
  <van-popup v-model:show="show" position="bottom" :close-on-click-overlay="false">
    <div class="bottomInstallBar">
      <div class="flex">
        <Image :src="config.logoUrl" alt="" class="size-16 mr-3" />
        <div class="leading-18">{{ bottomDownload }} </div>
      </div>
      <div class="flex-end-x mt-1 text-[var(--btn-text-color)] text-13">
        <span
          @click="show = false"
          class="w-23 h-8 flex-center rounded-8 mr-2.5 bd-[1px_var(--btn-text-color)] font-[600]"
        > {{ $t('Common.Cancel') }} </span>
        <Installation v-slot="{ start }">
          <span
            @click="start"
            class="w-23 h-8 bg-[--theme-primary] flex-center rounded-8 font-[600]"
            > {{ $t('home.install') }} </span>
        </Installation>
      </div>
    </div>
  </van-popup>
</template>

<script setup lang="ts">
  import config from '@/config'
  import Installation from '@a/components/Installation/index.vue'
  import { useHomeBannersAndTexts } from '@/store'

  const show = ref(true)
  const bottomDownload = computed(() => useHomeBannersAndTexts().bottomDownload?.asset)
  
  watch(bottomDownload, (val) => {
      show.value = !!val
  }, { immediate: true })
</script>

<style lang="scss">
.bottomInstallBar{
  @apply flex flex-col w-full shadow-md bg-white rounded-t-16 p-4 text-black;
}
</style>
